<template>
<!--
<transition
  name="fade"
  enter-active-class="fadeIn"
  leave-active-class="fadeOut"
>
<div class="md-layout mt-20 md-alignment-center-center">
  <div class="md-layout-item md-size-50 md-small-size-100">
    <md-card class="md-accent" md-with-hover :value="true">
      <md-ripple>
        <md-card-header>
          <div class="md-title">Hey!</div>
        </md-card-header>

        <md-card-content>
          {{text}}
        </md-card-content>

        <md-card-actions>
          <md-button @click="onClose">Okay</md-button>
        </md-card-actions>
      </md-ripple>
    </md-card>
  </div>
</div>
</transition>
-->
<v-alert error dismissible @input="onClose" :value="true">
  {{ text }}
</v-alert>
</template>

<script>
  export default {
    props: ['text'],
    methods: {
      onClose () {
        this.$emit('dismissed')
      }
    }
  }
</script>

<style lang="stylus" scoped>
.md-theme-darker
    .md-card-header
      background-color red!important
      .md-title
        color white!important
    .md-card-content
      background-color red!important
      color white!important
    .md-card-actions
      background-color red!important
      .md-button
        background-color red!important
        color white!important
</style>